var map = {
	"./1/symbol_0.png": "2b21",
	"./1/symbol_1.png": "b028",
	"./1/symbol_10.png": "c22c",
	"./1/symbol_11.png": "8f40",
	"./1/symbol_12.png": "71ae",
	"./1/symbol_2.png": "210a",
	"./1/symbol_3.png": "da4b",
	"./1/symbol_4.png": "1ed0",
	"./1/symbol_5.png": "7c6c",
	"./1/symbol_6.png": "225f",
	"./1/symbol_7.png": "1aa2",
	"./1/symbol_8.png": "3568",
	"./1/symbol_9.png": "97ee",
	"./2/symbol_0.png": "a6782",
	"./2/symbol_1.png": "06f3",
	"./2/symbol_10.png": "d0c2",
	"./2/symbol_11.png": "faa9",
	"./2/symbol_12.png": "2f421",
	"./2/symbol_2.png": "2935",
	"./2/symbol_3.png": "5c48",
	"./2/symbol_4.png": "ab44",
	"./2/symbol_5.png": "16d5",
	"./2/symbol_6.png": "8552",
	"./2/symbol_7.png": "3ec1",
	"./2/symbol_8.png": "a0e9",
	"./2/symbol_9.png": "c4a3",
	"./3/symbol_0.png": "67aa",
	"./3/symbol_1.png": "58d3",
	"./3/symbol_10.png": "d57e",
	"./3/symbol_12.png": "cb98",
	"./3/symbol_2.png": "77e4",
	"./3/symbol_3.png": "71ad",
	"./3/symbol_4.png": "6f65",
	"./3/symbol_5.png": "13ce",
	"./3/symbol_6.png": "fdbd",
	"./3/symbol_7.png": "5fcf",
	"./3/symbol_8.png": "4ddb1",
	"./3/symbol_9.png": "c85b",
	"./4/symbol_0.png": "825a",
	"./4/symbol_1.png": "6c3a",
	"./4/symbol_10.png": "3bda",
	"./4/symbol_12.png": "3212",
	"./4/symbol_2.png": "1573",
	"./4/symbol_3.png": "fc4c",
	"./4/symbol_4.png": "7ff0",
	"./4/symbol_5.png": "333d",
	"./4/symbol_6.png": "1c9c",
	"./4/symbol_7.png": "c679",
	"./4/symbol_8.png": "de6c",
	"./4/symbol_9.png": "d338",
	"./gold1.png": "bc6e",
	"./gold2.png": "9af2",
	"./gold3.png": "b97c",
	"./gold4.png": "7c99",
	"./lose.png": "e82a",
	"./silver1.png": "4f9f",
	"./silver2.png": "867d",
	"./silver3.png": "90de",
	"./silver4.png": "0d38",
	"./slotmachine.png": "4e7e",
	"./win.png": "92f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5db4";